import * as THREE from 'three';

export class MedialDivider{
	//width: 分隔带宽度，height：分隔带高度，startStake：分隔带起始桩号， endStake：分隔带终止桩号，roadStakes:道路桩数据，dividerType：分隔带类型
	constructor(width, height, startStake, endStake, roadStakes,dividerType){
		this.width = width;
		this.height = height;
		this.dividerType = dividerType;
		this.startStake = startStake;
		this.endStake = endStake;
		this.roadStakes = roadStakes;
		//计算roadstake的中央分隔带参数
		this.roadStakes.map(item=>{
			item.roadElementParams.medialDivider.width = width;
			item.roadElementParams.medialDivider.height = height;
		});
	}
}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/models/MedialDivider.js